import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Target01 = function Target01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M22 12c0 5.5228-4.4772 10-10 10m10-10c0-5.5228-4.4772-10-10-10m10 10h-4m-6 10C6.4772 22 2 17.5228 2 12m10 10v-4M2 12C2 6.4772 6.4772 2 12 2M2 12h4m6-10v4"
    })
  }));
};
export default Target01;